export const navItems = [
    {
      label: 'Home',
      link: '/',
    },
    {
      label: 'About',
      link: '/About',
    },
        {
      label: 'Careers',
      link: '/Careers',
    },
    {
      label: 'Services',
      link: '/Services',
    },
    {
      label: 'Our Work',
      link: '/OurWork',
    },
     {
      label: 'Contact',
      link: '/Contact',
    },
  ];
  